export const handleFilters = (data, filters) => {
    return data.filter(item => {
        return Object.entries(filters).every(([key, filter]) => {
            switch (key) {
                case "status":
                    if (!filter) return true;
                    const value = filter === "active";
                    return item[key] === value
                case "loginBlocked":
                    if (!filter) return true;
                    return item[key] === filter;
                case "groups":
                    if (!filter || filter.length === 0) return true;
                    const filterIds = filter.map(el => el.value);
                    const itemIds = item[key]?.map(el => el.id);
                    return itemIds.some(id => filterIds.includes(id));
                case "accessGroupsVms":
                    if (!filter || filter.length === 0) return true;
                    const filterNames = filter.map(el => normalizer(el.value));
                    const itemGroupNames = item.vmsUserConfiguration
                        ?.flatMap(cfg => cfg?.userAccessGroups || [])
                        .map(g => g?.accessGroup?.groupName)
                        .filter(Boolean)
                        .map(name => normalizer(name));
                    return itemGroupNames?.some(name => filterNames.includes(name));
                case "cpf":
                    if (!filter) return true;
                    const cpf = filter.replace(/[.*+?^${}()|[\]\\-\s]/g, '');
                    return item[key] === cpf;
            }

            if (filter && !item[key]) return false
            if (!item[key]) return true;

            return normalizer(item[key]).includes(normalizer(filter));
        });
    });
}

const normalizer = str => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
